import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import {
  DynamicMenuSetting,
  LoadDynamicMenuDataPayload,
  SaveDynamicMenuDataPayload,
} from './models/dynamicMenuSetting';

const dynamicMenuService = {
  loadDynamicMenuData(payload: LoadDynamicMenuDataPayload): Promise<CommonResponse<DynamicMenuSetting>> {
    const url = `/menu-book-editor/load-dynamic-menu-data`;
    return axiosClient.post(url, payload);
  },
  saveDynamicMenuData(payload: SaveDynamicMenuDataPayload): Promise<CommonResponse<any>> {
    const url = `/menu-book-editor/save-dynamic-menu-data`;
    return axiosClient.post(url, payload);
  },
};

export default dynamicMenuService;
